import { ref, watch } from 'vue';
import { useCookies } from '@vueuse/integrations/useCookies';
import type { LanguageCode } from '@/types';

export function useGlobalSingleton() {
  const LANGUAGE_COOKIE = 'langcode';

  const isPoiFocused = ref(false);
  const isLoadingScreenTransitionstartActive = ref(false);
  const isLoadingScreenTransitionendActive = ref(false);
  const isDragging = ref(false);
  const language = ref<LanguageCode>('en');

  const cookies = useCookies([LANGUAGE_COOKIE]);
  const cookieLanguage = cookies.get<LanguageCode>(LANGUAGE_COOKIE);
  if (cookieLanguage) {
    language.value = cookieLanguage;
  }

  watch(language, (newValue) => {
    if (newValue) {
      cookies.set(LANGUAGE_COOKIE, newValue);
    }
  });

  return {
    isPoiFocused,
    isLoadingScreenTransitionstartActive,
    isLoadingScreenTransitionendActive,
    isDragging,
    language,
  };
}

const cached = useGlobalSingleton();
export const useGlobal = () => cached;
